export const sanitizerFileName = (fileName: string): string => {
  return fileName
    .replace(/[^\w\s.-]/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase()
}
